import React, { useMemo } from 'react';
import { breakpointValues } from '../constants';

const ResponsiveImage = ({
  sizeDefinitions,
  alt,
  lazyLoad = false,
  onClick,
  className,
}) => {
  const smallestImage = useMemo(
    () => sizeDefinitions?.slice().sort((a, b) => a.width - b.width)[0],
    [sizeDefinitions]
  );

  const orderedSizeDefinitions = useMemo(
    () =>
      sizeDefinitions
        ?.slice()
        .sort(
          (a, b) =>
            (b.fromWidth ?? breakpointValues[b.fromBreakpoint ?? '']) -
            (a.fromWidth ?? breakpointValues[a.fromBreakpoint ?? ''])
        ),
    [sizeDefinitions]
  );

  return (
    <picture>
      {orderedSizeDefinitions &&
        orderedSizeDefinitions.length > 1 &&
        orderedSizeDefinitions.map((img, idx) => (
          <source
            key={img.url + idx + 'source'}
            srcSet={img.url}
            media={`(min-width: ${
              img.fromWidth ?? breakpointValues[img.fromBreakpoint ?? '']
            }px)`}
          />
        ))}
      <img
        src={smallestImage?.url}
        loading={lazyLoad ? 'lazy' : undefined}
        alt={alt}
        width={!!smallestImage?.width ? smallestImage?.width : undefined}
        itemProp="image"
        height={!!smallestImage?.height ? smallestImage?.height : undefined}
        onClick={onClick}
        className={className}
      />
    </picture>
  );
};

export default ResponsiveImage;
